import { useEffect, useState } from "react";
import { BarChart3, FileText, Megaphone, Search, UserPlus, Users } from "lucide-react";
import { Mascot, Script } from "./Script";
import { reducedMotion } from "../../lib/motion";

const AGENTS = [[FileText, "Contenu", "cyan"], [UserPlus, "Prospects", "magenta"], [Users, "Clients", "amber"],
  [Search, "Recherche", "violet"], [Megaphone, "Marketing", "cyan"], [BarChart3, "Finance", "magenta"]];
const TASKS = ["Article de blog préparé", "Nouveau prospect qualifié", "Réponse client envoyée", "Veille concurrentielle à jour",
  "Publication planifiée", "Factures classées"];

const useTick = (ms) => {
  const [t, setT] = useState(0);
  useEffect(() => {
    if (reducedMotion()) return undefined;
    const id = setInterval(() => setT((x) => x + 1), ms);
    return () => clearInterval(id);
  }, [ms]);
  return t;
};

const Dashboard = () => {
  const t = useTick(2200);
  const list = [0, 1, 2, 3].map((i) => TASKS[(t + i) % TASKS.length]);
  return (
    <div className="dash">
      <aside className="dash-side"><i /><i /><i /><i /></aside>
      <div className="dash-main">
        <b className="dash-hi">Bienvenue !</b>
        <span className="dash-sub">Vos agents travaillent pour vous</span>
        <div className="dash-cards">
          {AGENTS.map(([Icon, label, c], i) => (
            <div key={label} className={`dash-card ${i === t % 6 ? "is-busy" : ""}`} style={{ "--c": `var(--${c})` }}>
              <Icon aria-hidden="true" /><span>{label}</span><em>{i === t % 6 ? "En cours" : "Actif"}</em>
            </div>
          ))}
        </div>
        <div className="dash-act">
          <span className="dash-act-h">Activité récente</span>
          {list.map((x, i) => <div key={`${x}-${t}`} className="dash-row" style={{ "--i": i }}><i />{x}<em>{i === 0 ? "En cours" : "Terminé"}</em></div>)}
        </div>
      </div>
    </div>
  );
};

export const HeroScene = () => {
  const move = (e) => {
    if (e.pointerType !== "mouse") return;
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--px", ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
    e.currentTarget.style.setProperty("--py", ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
  };
  return (
    <div className="scene" onPointerMove={move} role="img" aria-label="Tableau de bord NovaSoft : vos agents IA travaillent pour vous" data-testid="hero-scene">
      <div className="scene-in" aria-hidden="true">
        <div className="lap"><div className="lap-screen"><Dashboard /></div><div className="lap-base" /></div>
        <div className="phone hero-phone">
          <b>Bonjour !</b><span>Votre équipe IA est prête</span>
          {AGENTS.slice(0, 4).map(([Icon, label, c]) => <div key={label} className="ph-row" style={{ "--c": `var(--${c})` }}><Icon /><span>{label}</span></div>)}
        </div>
        <Mascot kind="main" className="sm-main par-3" eager blink />
        <Mascot kind="magenta" className="sm-mag par-2" />
        <Mascot kind="green" className="sm-green par-1" />
        <Mascot kind="amber" className="sm-amber par-2" />
        <Script className="scene-script">Plus loin, ensemble</Script>
      </div>
    </div>
  );
};
